import { _ } from 'svelte-i18n';
import { get } from 'svelte/store';
import type { MapLayerOneType } from './MapLayerApi';

export class MapLayerInserter {
    static insertLayersToMap(
        map: any,
        layers: MapLayerOneType[],
        onTurnOn: (id: string) => void,
        onTurnOff: (id: string) => void
    ) {
        layers.forEach(l => {
            this.insertLayerToMap(map, l, onTurnOn, onTurnOff);
        });
    }

    private static _improveTileUrl(tileUrl: string) {
        return tileUrl.replace(
            /^https?:\/\/(img|mapa)\.targeo\.pl\//,
            // @ts-ignore
            _TARGEO_GLOBALS.url
        );
    }

    public static insertLayerToMap(
        map: any,
        layer: MapLayerOneType,
        onTurnOn: (id: string) => void,
        onTurnOff: (id: string) => void
    ) {
        // https://mapa.targeo.pl/docs3/Targeo.modules.Layers.html

        if (typeof Targeo === 'undefined') {
            console.error('Targeo is not defined in _insertLayerToMap');
            return;
        }

        let tileLayer = new Targeo.TileLayer(layer.id, {
            maxtries: layer.maxtries,
            tileUrl: this._improveTileUrl(layer.tile_url),
            visible: true, // must be true to be available in plugin
            zIndex: layer.z_index,
            opacity: layer.opacity,
        });

        map.modules.Layers.registerLayer(layer.id, {
            label: get(_)(layer.label),
            visible: true,
            handler: (visible: boolean) => {
                if (visible) {
                    console.log('add layer', visible, tileLayer);
                    map.tileLayerAdd(tileLayer);
                    onTurnOn(layer.id);
                } else {
                    console.log('remove layer', visible, tileLayer);
                    map.tileLayerRemove(tileLayer.name);
                    onTurnOff(layer.id);
                }
            },
            priority: layer.priority,
        });

        if (layer.visible) {
            map.modules.Layers.toggleLayer(layer.id, true);
            // map.modules.Layers.enableLayer(layer.id);
        } else {
            map.modules.Layers.toggleLayer(layer.id, true); // hack: reload layer to be enabled in plugin
            map.modules.Layers.toggleLayer(layer.id, false);
        }
    }

    static discardLayer(map: any, layerId: string): void {
        if (typeof Targeo === 'undefined') {
            console.error('Targeo is not defined in _discardLayer');
            return;
        }
        map.modules.Layers.discardLayer(layerId);
    }
}
